import {fetchWallboardConfig} from "../../api/mainApi";

export default {
    namespaced: true,
    state: {
        wallboardName: "",
        extensionLength: 5
    },
    getters: {
        wallboardName: (state) => {
            return state.wallboardName
        },
        extensionLength: (state) => {
            return state.extensionLength
        }
    },
    actions: {
        getConfig: (context) => {
            return fetchWallboardConfig()
                .then((response) => {
                    context.commit("setData", response.data)
                })
        }
    },
    mutations: {
        setData: (state, data) => {
            state.wallboardName = data.wallboard_name
            state.extensionLength = data.extension_length
        },
    }
}